import axios from "axios";
import { notification } from "ant-design-vue";
// 允许携带cookie
axios.defaults.withCredentials=true;
// let BASEURL="http://0.0.0.0:3000/api/v1.0"
let BASEURL="https://eic.blueballon.cn/api/v1.0"
axios.defaults.baseURL = BASEURL;

function request(options) {
  return axios(options)
    .then(res => {
        console.log("看看请求的数据document.cookie",res,document.cookie)
      return res;
    })
    .catch(error => {
      const {
        response: { status, statusText }
      } = error;
      notification.error({
        // eslint-disable-next-line no-unused-vars
        message: h => (
          <div>
            请求错误 <span style="color: red">{status}</span> : {options.url}
          </div>
        ),
        description: statusText
      });
      return Promise.reject(error);
    });
}

export default request;
